import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { getUserRoles } from "./Utils";

const ProtectedRoute = ({ access_roles, publicAccess = false }) => {
  const location = useLocation();
  const userInfo = localStorage.getItem("DfsWeb.user-info");
  const userRoles = getUserRoles();
  const access_token = localStorage.getItem("DfsWeb.access-token");

  if (publicAccess && (!userInfo || !access_token)) {
    return <Outlet />;
  }
  if (!userInfo || !access_token) {
    return (
      <Navigate
        to={`${window.contextPath}/`}
        state={{ from: location }}
        replace
      />
    );
  }
  if (access_roles && !access_roles.some((role) => userRoles.includes(role))) {
    return (
      <Navigate
        to={`${window.contextPath}/home`}
        state={{ from: location }}
        replace
      />
    );
  }
  if (access_roles && access_roles.some((role) => userRoles.includes(role))) {
    return <Outlet />;
  }
};

ProtectedRoute.propTypes = {
  children: PropTypes.element,
};

export default ProtectedRoute;
